"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=message-template.dto.js.map